import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  pdf,
} from "@react-pdf/renderer";
import {
  AddonHelper,
  EVatRate,
  Product,
} from "../../../classes/types/product/product";
import { AddonCartHelper } from "../../../classes/types/cart/cart";
import {
  DataTableCell,
  Table,
  TableCell,
  TableHeader,
  TableBody,
} from "@david.kucsai/react-pdf-table";
import { saveAs } from 'file-saver';
import { euroPrint } from "../../../classes/types/currencysettings";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
});

class CostRow {
  constructor(name: string, value: number) {
    this.name = name;
    this.value = value;
  }

  name: string;
  value: number;
}

class ConfigurationRow {
  constructor(name: string, option: string, qty: number, total: number) {
    this.name = name;
    this.option = option;
    this.qty = qty;
    this.total = total;
  }

  name: string;
  option: string;
  qty: number;
  total: number;
}

const generateConfigurationRowData = (
  productAddons: AddonHelper[],
  selectedOptions: AddonCartHelper[]
): ConfigurationRow[] => {

  const usedOptions = new Set<number>();

  return productAddons.map((addon) => {

    const optionIndex = selectedOptions.findIndex(
      (option, index) =>
        !usedOptions.has(index) &&
        option.selectedAddon.id === addon.addon.id
    );

    if (optionIndex === -1) {
      return new ConfigurationRow(
        addon.addon.name,
        "NESSUNO",
        0,
        0
      );
    }

    usedOptions.add(optionIndex);

    const foundSelectedOption = selectedOptions[optionIndex];

    const foundPrice =
      (foundSelectedOption.selectedAddon.selectedOption?.price ?? 0) > 0
        ? (foundSelectedOption.selectedAddon.selectedOption?.price ?? 0)
        : foundSelectedOption.selectedAddon.selectedOptionPrice;

    return new ConfigurationRow(
      addon.addon.name,
      foundSelectedOption.selectedAddon.addonName,
      foundSelectedOption.selectedAddon.selectedQuantity,
      foundPrice
    );
  });
};

const generateTotals = (
  product: Product,
  rows: Array<ConfigurationRow>,
  qty: number
): Array<CostRow> => {
  console.warn("WARN HERE");
  console.log(product);
  console.log(rows);
  let productBaseCost: number =
    (product.price !== undefined ? product.price : 0) * qty;
  let addonsCost: number = 0;
  let siaeCost: number = product.taxSIAE * qty;
  let totalVat: number = 0;
  for (let i = 0; i < qty; i++) {
    rows.forEach((confRow: ConfigurationRow) => {
      addonsCost += confRow.total * confRow.qty;
    });
  }

  let productTotal = productBaseCost + addonsCost;
  console.log(productTotal);
  if (product.vatRate === EVatRate.Vat22) {
    totalVat = productTotal * 1.22 - productTotal + siaeCost * 1.22 - siaeCost;
  }
  let costRowArray: Array<CostRow> = [
    new CostRow("Prodotto", productTotal),
    new CostRow("Compenso SIAE", siaeCost),
    new CostRow("IVA", totalVat),
    new CostRow("Totale", productTotal + siaeCost + totalVat),
  ];
  return costRowArray;
};

interface IDocumentProps {
  product: Product;
  productAddons: Array<AddonHelper>;
  quantity: number;
  selectedAddons: Array<AddonCartHelper>;
}

// Create Document Component
const ConfigurationDocument = (props: IDocumentProps) => {
  let configRows = generateConfigurationRowData(
    props.productAddons,
    props.selectedAddons
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Image
            style={{ height: 50, width: 50 }}
            source={
              "data:image/png;base64,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"
            }
          />
          <Text style={{ marginBottom: 20, marginTop: 20 }}>{props.product.name}</Text>
          <Text style={{ marginBottom: 20 }}>Configurazione prodotto</Text>
          <Table data={configRows}>
            <TableHeader>
              <TableCell textAlign={"center"}>Nome</TableCell>
              <TableCell textAlign={"center"}>Opzione</TableCell>
              <TableCell weighting={0.4} textAlign={"center"}>Quantità</TableCell>
              <TableCell weighting={0.5} textAlign={"center"}>Prezzo</TableCell>
            </TableHeader>
            <TableBody evenRowColor="lightgray">
              <DataTableCell
                getContent={(addon: ConfigurationRow) => addon.name}
              />
              <DataTableCell
                getContent={(addon: ConfigurationRow) => addon.option}
              />
              <DataTableCell
                weighting={0.4}
                getContent={(addon: ConfigurationRow) => addon.qty}
              />
              <DataTableCell
                weighting={0.5}
                getContent={(addon: ConfigurationRow) => euroPrint(addon.total)}
              />
            </TableBody>
          </Table>
          <Text style={{ marginBottom: 20, marginTop: 20 }}>Riepilogo Costi</Text>
          <Table
            data={generateTotals(props.product, configRows, props.quantity)}
          >
            <TableBody>
              <DataTableCell getContent={(row: CostRow) => row.name} />
              <DataTableCell
                getContent={(row: CostRow) => euroPrint(row.value)}
              />
            </TableBody>
          </Table>
          <Text style={{ marginBottom: 15, marginTop: 15 }}>*Documento non valido per fini fiscali</Text>
          <Text style={{ marginBottom: 15, marginTop: 15 }}>**I prezzi e le disponibilità sono soggetti a variazioni senza alcun preavviso. Richiedi sempre verifica della configurazione al tuo Consulente Commerciale di riferimento.</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ConfigurationDocument;
